import { MutableRefObject, useRef } from 'react';

import { PaymentsAuthAPIServiceTypes } from '../../services/PaymentsAuthServices/APIService';
import { PaymentsAuthAPIService } from '../../services/PaymentsAuthServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const usePaymentsAuthAPIService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();
  const PaymentsAuthAPIRef: MutableRefObject<PaymentsAuthAPIServiceTypes | null> =
    useRef(null);

  if (PaymentsAuthAPIRef.current === null) {
    PaymentsAuthAPIRef.current = new PaymentsAuthAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    paymentsAuthAPIService: PaymentsAuthAPIRef.current
  };
};

export { usePaymentsAuthAPIService };
